import { toast as hotToast } from 'react-hot-toast'
import { Icon } from '@/components/icon'
import {
  faCheckDouble,
  faInfo,
  faXmark
} from '@fortawesome/free-solid-svg-icons'

/**
 * A utility component for displaying a toast message.
 *
 * Usage:
 *
 * import { toast } from "@ui/toast"
 *
 * toastSuccess("Your message")
 * toastError("Your message")
 * toastInfo("Your message")
 */

export const toastSuccess = (msg: string) =>
  hotToast(msg, {
    duration: 3500,
    icon: <Icon icon={faCheckDouble} size={20} />,
    className: 'Success'
  })

export const toastError = (msg: string, timeout?: number, id?: string) =>
  hotToast(msg, {
    duration: timeout ?? 20000,
    icon: <Icon icon={faXmark} size={20} />,
    className: 'Error',
    id: id // Unique ID prevents duplicate toasts
  })

export const toastInfo = (msg: string) =>
  hotToast(msg, {
    icon: <Icon icon={faInfo} size={20} />,
    className: 'Info'
  })
